<template>
  <div style="padding: 30px">
    <div class="transTable">
      <div class="tableLeft">
        <el-table :row-style="{height:'20px'}" :cell-style="{padding:'0px'}" ref="myLeftTable" :data="leftData"
                  max-height="400" border
                  @selection-change="handleLeftContentSelectionChange"
                  @row-click="checkLeftRow">
          <el-table-column
              type="selection"
              width="40">
          </el-table-column>
          <el-table-column>
            <template #header>
              {{ leftTitle + '(' + checkLeftData.length + '/' + leftAllData.length + ')' }}
              <div>
                <el-input class="searchData" style="margin-top: 10px"
                          placeholder="搜索样品名" v-model="searchLeftData"
                          @input="handleInput('left',leftAllData,searchLeftData,checkLeftData,false)">
                  <template #suffix>
                    <i class="el-icon-circle-close" style="cursor: pointer" @click="clearSearch('left',checkLeftData)"></i>

                  </template>
                </el-input>
              </div>
            </template>
            <template slot-scope="scope">
              <span style="cursor: pointer">{{ scope.row.content }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="tableCenter">
        <el-button type="primary" icon="el-icon-arrow-right" title="右移"
                   :disabled="(!checkLeftData || checkLeftData.length === 0)"
                   @click="toRight"></el-button>
        <el-button type="primary" icon="el-icon-arrow-left" style="margin-left: 0!important;margin-top: 12px"
                   :disabled="(!prepareToLeft || prepareToLeft.length === 0)" title="选中部分左移"
                   @click="toLeft"></el-button>
        <el-button type="primary" icon="el-icon-d-arrow-left" style="margin-left: 0px!important;margin-top: 12px"
                   title="全部左移"
                   :disabled="rightData.length===0"
                   @click="toLeftAll"></el-button>
      </div>
      <div class="tableRight">
        <el-table :row-style="{height:'20px'}" :cell-style="{padding:'0px'}" ref="myRightTable"
                  :data="isGroup?rightData:changeRightData" max-height="400" border
                  @selection-change="handleRightGroupSelectionChange"
                  @row-click="checkRightRow">
          <el-table-column
              type="selection"
              width="40">
          </el-table-column>
          <el-table-column>
            <template #header>
              <div style="display: flex;justify-content: space-between">
                <span> {{ rightTitle + '(' + rightAllData.length + ')' }}</span>
              </div>
              <div>
                <el-input class="searchData" style="margin-top: 10px"
                          :placeholder="isGroup?'搜索组名':'搜索样品名'" v-model="searchRightData"
                          @input="handleInput('right',rightAllData,searchRightData,checkRightData,isGroup)">
                  <template #suffix>
                    <i class="el-icon-circle-close" style="cursor: pointer" @click="clearSearch('right',checkRightData)"></i>
                  </template>
                </el-input>
              </div>
            </template>

            <template slot-scope="scope">
              <div class="sample-group-item" v-if="isGroup">
                <div class="sample-group-item-contents">
                  <el-checkbox-group v-model="groupMove" @change="checkRightContent(scope.row)">
                    <el-checkbox v-for="(sampleName,index) in scope.row.contents" :label="sampleName"
                                 :key="index+'sample'">{{ sampleName.content }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <el-input v-model.trim="scope.row.groupName"
                         class="inputGroupName"
                          placeholder="请输入组名"></el-input>
              </div>
              <span v-else style="cursor: pointer">{{ scope.row.content }}</span>
            </template>
          </el-table-column>
        </el-table>
        <span style="font-size: 13px;color: #b6b6b6;margin-top: 20px">{{ notice }}</span>
      </div>
    </div>
    <slot name="otherCon">

    </slot>
    <div style="margin-top: 40px;display: flex;justify-content: flex-end">
      <el-button @click="handleCancel">{{ cancelText }}</el-button>
      <el-button type="primary" @click="handleConfirm">{{ saveText }}</el-button>
    </div>
  </div>
</template>
<script>
import {isSameArr} from "./utils/index";

export default {
  name: "WTransform",
  props: {
    leftDatas: {
      // 控制是否显示 Dialog
      type: Array,
      default: [],
    },
    rightDatas: {
      type: Array,
      default: [],
    },
    leftTitle: {
      type: String,
      default: "左边",
    },
    rightTitle: {
      type: String,
      default: "右边",
    },
    notice: {
      type: String,
      default: "",
    },
    isGroup: {
      type: Boolean,
      default: false,
    },
    saveText: {
      type: String,
      default: "确定",
    },
    cancelText: {
      type: String,
      default: "取消",
    },
  },
  data() {
    return {
      // title: '输入分组',
      leftData: [],
      rightData: [],//分组
      changeRightData: [],//不分组

      checkLeftData: [],//已选中的左侧数据
      checkRightData: [],//已选中的左侧数据

      groupMove: [],//右边整组移动
      prepareToLeft: [],//已选中的右侧数据

      //搜索内容
      searchLeftData: null,
      searchRightData: null,

      //所有样品
      leftAllData: null,
      rightAllData: null,
    }
  },
  created() {
    // this.initializeData()
    // if (!this.isGroup) {
    //   // 不分组
    //   let rightData = []
    //   this.rightDatas.map((item, index) => {
    //     rightData.push({
    //       groupName: '',
    //       contents: [{id: item.id ? item.id : index, content: item.content}]
    //     })
    //   })
    //   this.rightData = rightData
    // } else {
    //   this.rightData = []
    //   this.rightData = JSON.parse(JSON.stringify(this.rightDatas))
    // }
    // this.rightAllData = this.rightData

  },
  watch: {
    rightDatas:{
      handler:function (newVal) {
          if (!this.isGroup) {
            // 不分组
            let rightData = []
            this.rightDatas.map((item, index) => {
              rightData.push({
                groupName: '',
                contents: [{id: item.id ? item.id : index, content: item.content}]
              })
            })
            this.rightData = rightData
          } else {
            this.rightData = []
            this.rightData = JSON.parse(JSON.stringify(this.rightDatas))
          }
          this.rightAllData = this.rightData
      },
      immediate:true,
      deep:true

    },
    rightData: {
      handler(newValue, oldValue) {
      //   //不分组
      //   if (!this.isGroup) {
      //     this.changeRightData = this.flattenRightData(this.rightData);
      //     this.rightAllData = this.changeRightData;
      //   }
      // },

        let changeRightData = []
        if (!this.isGroup) {
          newValue.forEach(row => {
            row.contents.forEach(content => {
              changeRightData.push(content)
            })
          })
          this.changeRightData = changeRightData
          this.rightAllData = this.changeRightData
        }
      },
      immediate: true
    },
    leftDatas: {
      handler(newValue, oldValue) {
        // this.initializeData()

        this.leftAllData = newValue.map((item, index) => {
          return {
            'content': item.content,
            id: item.id ? item.id : index
          }
        })
        this.leftData = this.leftAllData
      },
      immediate: true,
    },
  },
  // computed: {
  //   filteredLeftData() {
  //     return this.filterData(this.leftAllData, this.searchLeftData, this.checkLeftData);
  //   },
  //   filteredRightData() {
  //     return this.filterData(this.rightAllData, this.searchRightData, this.checkRightData, this.isGroup);
  //   },
  // },
  methods: {
    // initializeData() {
    //   this.leftAllData = this.leftDatas.map((item, index) => ({
    //     content: item.content,
    //     id: item.id || index,
    //   }));
    //   this.leftData = this.leftAllData;
    //
    //   if (this.isGroup) {
    //     this.rightData = JSON.parse(JSON.stringify(this.rightDatas));
    //     this.rightAllData = this.rightData;
    //   } else {
    //     this.rightData = this.rightDatas.map((item, index) => ({
    //       groupName: '',
    //       contents: [{id: item.id || index, content: item.content}],
    //     }));
    //   }
    // },
    // flattenRightData(data) {
    //   return data.reduce((acc, item) => [...acc, ...item.contents], []);
    // },
    // filterData(data, searchText, checkData, isGroup = false) {
    //   if (!searchText) return data;
    //   let filtered = data.filter((item) =>
    //       isGroup ? item.groupName.includes(searchText) : item.content.includes(searchText)
    //   );
    //   let checked = data.filter((item) =>
    //       checkData.some((checkedItem) =>
    //           isGroup ? checkedItem.groupName === item.groupName : checkedItem.content === item.content
    //       )
    //   );
    //   return [...new Set([...filtered, ...checked])];
    // },

    handleInput(flag, allData, searchData, checkData, isGroup) {
      // console.log(searchData)
      //手动清空
      if (searchData === '') {
        this.clearSearch(flag,checkData)
      } else {
        const filteredBySearch = isGroup
            ? allData.filter(item => item.groupName.includes(searchData))//分组
            : allData.filter(item => item.content.includes(searchData));//不分组

        const filteredByChecked = isGroup
            ? allData.filter(item => checkData.some(checkedItem => checkedItem === item))//分组
            : allData.filter(item => checkData.some(checkedItem => checkedItem.content === item.content));//不分组
        // 合并两个筛选结果并去重
        const mergedResults = [...new Set([...filteredBySearch, ...filteredByChecked])];

        if (flag === 'left') {
          this.leftData = mergedResults
        } else {
          this.updateRightData(mergedResults)
        }
      }
      // 恢复已选中状态
      this.restoreSelection(flag, checkData)
    },
    // 清空搜索框
    clearSearch(flag, checkData) {
      if (flag === 'left') {
        this.searchLeftData = ''
        this.leftData = this.leftAllData
      } else {
        this.searchRightData = ''
        this.updateRightData(this.rightAllData)
      }
      // 恢复已选中状态
      this.restoreSelection(flag, checkData)
    },
    updateRightData(data){
      if (this.isGroup) {
        this.rightData = data
      } else {
        this.changeRightData = data
      }
    },
    // 恢复已选中状态
    restoreSelection(flag, checkData) {
      this.$nextTick(() => {
        let table = flag === 'left' ? this.$refs.myLeftTable : this.$refs.myRightTable
        table.clearSelection();
        checkData.forEach((item) => table.toggleRowSelection(item, true));// 手动选中每行
      });
    },
    //点击右移按钮
    toRight() {
      this.moveSelectedDataToRight()//修改右侧数据----增加
      this.updateLeftData()//修改左侧数据----减少
      this.searchLeftData = ''
      this.searchRightData = ''
      this.rightAllData = this.rightData
      this.restoreSelection('right', this.checkRightData)


    },
    //修改右侧数据----增加
    moveSelectedDataToRight() {
      const modifiedCheckLeftData = this.checkLeftData.map(item => ({
        ...item,
        flag: false
      }));
      this.rightData.push({
        contents: modifiedCheckLeftData,
        groupName: ''
      });
    },
    //修改左侧数据----减少
    updateLeftData() {
      this.leftAllData = this.leftAllData.filter(item =>
          !this.checkLeftData.some(checkedItem => checkedItem.content === item.content)
      );
      this.leftData = [...this.leftAllData];
      this.checkLeftData = [];
    },

    //点击左移按钮
    toLeft() {
      this.moveSelectedDataToLeft()//修改左侧数据----增加
      this.filterRightData()//修改右侧数据----减少
      this.resetRightSelection()//重置右侧勾选数据
      this.searchLeftData = ''
      this.searchRightData = ''
    },
    //修改左侧数据----增加
    moveSelectedDataToLeft() {
      const modifiedPrepareToLeft = this.prepareToLeft.map(item => ({
        ...item,
        flag: false
      }));
      this.leftAllData.push(...modifiedPrepareToLeft);
      this.leftData = [...this.leftAllData];
      this.restoreSelection('left', this.checkLeftData)
    },
    // 修改右侧数据----减少
    filterRightData() {
      this.rightData = this.rightData.map(group => ({
        ...group,
        contents: group.contents.filter(content => !this.prepareToLeft.includes(content))
      })).filter(group => group.contents.length > 0);
    },
    //重置右侧勾选数据
    resetRightSelection() {
      this.groupMove = [];
      this.prepareToLeft = [];
      this.rightAllData = [...this.rightData];
    },
    //点击全部左移按钮
    toLeftAll() {
      this.rightData.forEach(item => {
        item.contents.forEach(i => {
          i.flag=false
          this.leftAllData.push(i)
        })
      })
      this.leftData=[...this.leftAllData]
      this.restoreSelection('left', this.checkLeftData)

      this.rightData = []
      this.resetRightSelection()//重置右侧勾选数据
      this.searchLeftData = ''
      this.searchRightData = ''

    },
    //选择右边这边每组里面的细分的勾选框
    checkRightContent(row) {
      //单个样品解决了 多个依次勾选还未解决
      let rowSample = row.contents.map(item => item.content)
      let checkSample = this.groupMove
          .filter(item =>
              !this.prepareToLeft.some(leftItem => leftItem.content === item.content)
          )
          .map(item => item.content);
      let flag = isSameArr(rowSample, checkSample)
        this.$refs.myRightTable.toggleRowSelection(row, flag)
      this.prepareToLeft = [...this.groupMove];
    },
    //点击右边的勾选框（整行，包括一个组里面的细分）
    handleRightGroupSelectionChange(prepareToLeft) {
      let contentsArr = []
      // 有选中值
      if (prepareToLeft.length > 0) {

        contentsArr = this.isGroup
            ? prepareToLeft.flatMap(item => item.contents)
            : [...prepareToLeft];
      }
      this.prepareToLeft = contentsArr
      this.groupMove = contentsArr
      this.checkRightData = prepareToLeft
    },
    //点击左边的勾选框
    handleLeftContentSelectionChange(checkedSample) {
      this.checkLeftData = [...checkedSample];
    },
    //控制右边表格框的勾选（即按行实现整行的勾选）
    checkRightRow(row, col, event) {
      if (!this.isGroup) {
        row.flag = !row.flag
        this.$refs.myRightTable.toggleRowSelection(row, row.flag)
      }
    },
    //控制左边的表格框的勾选（即按行实现整行的勾选）
    checkLeftRow(row, col, event) {
      row.flag = !row.flag
      this.$refs.myLeftTable.toggleRowSelection(row, row.flag)
    },
    handleConfirm() {
      let result = []
      if (this.isGroup) {
        result = this.rightData
      } else {
        this.changeRightData.map(item => {
          result.push(item)
        })
      }
      this.$emit('handleTrans', result, this.isGroup)
    },
    handleCancel() {
      this.$emit('handleTransCancel', this.isGroup)
    }
  }
}
</script>

<style scoped>
.tableCenter {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto 25px;
  justify-content: center;
}

::v-deep .div-sample-group .cell {
  padding: 0px;
}

.tableRight {
  min-width: 290px;
  margin-left: 20px;
}

.tableLeft {
  min-width: 200px;
}

.sample-group-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sample-group-item-contents div {
  width: 150px;
  padding: 0 10px;
}

.transTable {
  display: flex;
  justify-content: space-between;
  width: 100%;
  overflow-x: auto;
  /*padding-bottom: 20px;*/
  gap: 30px;
  /*padding: 30px;*/
  /*max-height: 400px;*/

}

::v-deep .el-checkbox {
  margin-bottom: auto !important;
}

::v-deep.el-table__body td {
  white-space: nowrap;
}

::v-deep.el-table__body-wrapper {
  max-height: 300px;
}

.search-container {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 3011;
  background-color: #ffffff;
  padding: 10px;
  border: 1px solid #cccccc;
}

/deep/ .el-input__inner {
  line-height: 30px;
  height: 30px;
}

/deep/ .el-input__suffix-inner {
  line-height: 30px;
}

.inputGroupName{
  //padding:2px 5px 2px 0;
  font-size: 12px;
}
/deep/ .gutter{
  width: 0!important;
  display: none!important;
}
</style>
